import Poi from './Poi'

class PoiData {

  constructor (json) {
    if (json) {
      /**
       * @type {Array<Poi>}
       */
      this.pois = this.initPois(json.data)
    }
    else {
      this.pois = []
    }

    /**
     * @type {{nw:{lat:number, lng: number}, sw: {lat: number, lng: number}}}
     */
    this.outerBounds = this.initOuterBounds()

    // this.paging = json.paging;
    // this.query = json.query;
  }

  clearData () {
    this.pois = []
    this.outerBounds = this.initOuterBounds()
  }

  /**
   * @returns {{minLat: *, maxLat: *, minLng: *, maxLng: *}}
   */
  initOuterBounds () {
    let minLat = 0
    let maxLat = 0
    let minLng = 0
    let maxLng = 0

    this.pois.forEach((poi) => {
      const position = poi.getPosition()

      if (!minLng || position.lng < minLng) {
        minLng = position.lng
      }
      if (!maxLng || position.lng > maxLng) {
        maxLng = position.lng
      }
      if (!minLat || position.lat < minLat) {
        minLat = position.lat
      }
      if (!maxLat || position.lat > maxLat) {
        maxLat = position.lat
      }
    })

    return {
      minLat,
      maxLat,
      minLng,
      maxLng
    }
  }

  initPois (data) {
    return data.map((poi) => {
      return new Poi(poi)
    })
  }

  /**
   *
   * @param radius
   * @returns {{minLat: number, maxLat: number, minLng: number, maxLng: number, nw: {lat: number, lng: number}, se: {lat: number, lng: number}}}
   */
  getOuterBounds (radius = 0) {
    const bounds = this.outerBounds

    bounds.nw = {
      lat: this.outerBounds.maxLat /* - 0.01 * radius */,
      lng: this.outerBounds.minLng /* - 0.01 * radius */
    }
    bounds.se = {
      lat: this.outerBounds.minLat /* + 0.01 * radius */,
      lng: this.outerBounds.maxLng /* + 0.01 * radius */
    }

    return bounds
  }

  /**
   *
   * @param id {string}
   * @return {Poi}
   */
  getPoi (id) {
    return this.pois.find(poi => poi.id === id)
  }

  /**
   *
   * @returns {Array.<Poi>}
   */
  getPois () {
    return this.pois
  }

  /**
   *  Adds the POIs of another PoiData to this one's.
   *
   * @param taData {PoiData}
   */
  mergeWithData (taData) {
    if (taData && taData.pois) {
      const existingIds = this.pois.map(poi => poi.id)

      const newPois = taData.getPois().filter(poi => {
        return existingIds.indexOf(poi.id) < 0
      })

      this.pois = this.pois.concat(newPois)

      this.outerBounds = this.initOuterBounds()
    }
  }

  /**
   * @param changedPoi {Poi}
   */
  replacePoi (changedPoi) {
    this.pois = this.pois.map(poi => {
      if (changedPoi.id === poi.id) {
        return changedPoi
      }
      return poi
    })
  }

}

export class PoiExtraData {

  constructor (json) {
    this.json = json
  }

  /**
   * @param poi {Poi}
   */
  applyToPoi (poi) {
    if (this.json) {
      Object.keys(this.json).forEach(key => {
        poi[key] = this.json[key]
        poi.extraData = true
      })
    }
    // return

    // if (this.description) {
    //   poi.setDescription(this.description)
    // }
    // if (this.photoUrl) {
    //   poi.setPhotoUrl(this.photoUrl)
    // }
    //
    // poi.setHasExtraData(true)
  }

  findBestPhotoUrl (photos) {
    const findBySource = (sourceToFind) => {
      return photos.find(photo => {
        return photo.source === sourceToFind
      })
    }

    let bestPhoto = findBySource('Management')

    if (!bestPhoto) {
      bestPhoto = findBySource('Expert')
    }

    if (!bestPhoto) {
      bestPhoto = findBySource('Traveler')
    }

    if (bestPhoto && bestPhoto.url) {
      return bestPhoto.url
    }
    return null
  }

}

export default PoiData



// WEBPACK FOOTER //
// ./src/data/PoiData.js